import { Flex } from '@radix-ui/themes';

const LoadingSpinner = () => {
    return (
        <Flex
            align="center"
            justify="center"
            style={{
                minHeight: '100vh'
            }}
        >
            <div
                style={{
                    width: '48px',
                    height: '48px',
                    border: '5px solid var(--gray-3)',
                    borderBottomColor: 'var(--accent-9)',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}
            />
            <style>
                {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
            </style>
        </Flex>
    );
};

export default LoadingSpinner;
